<section>
  <ion-row class="header-row ion-align-items-center">
    <ion-col>
      <h3 class="popup-heading ml-15">  {{ isEdit ? 'Update Product' : 'Add New Product' }}</h3>
    </ion-col>
    <ion-col size="auto">
      <button mat-icon-button mat-dialog-close class="close-btn">
        <ion-icon name="close-outline"></ion-icon>
      </button>
    </ion-col>
  </ion-row>

  <div class="addNewForm">
    <ion-row>    
      <ion-col size="12" size-lg="3" size-md="6">
        <label class="formLabelRegularfs16 mb-5">Product Number <span class="red-cl">*</span></label>
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <input matInput placeholder="  Product Number" maxlength="255" class="font_regular" [formControl]="productNumberCtrl" />
          <mat-error *ngIf="productNumberCtrl.invalid && productNumberCtrl.touched">Product No is required</mat-error>
        </mat-form-field>
      </ion-col>

      <ion-col size="12" size-lg="3" size-md="6" >
        <label class="formLabelRegularfs16 mb-5">Product Name <span class="red-cl">*</span></label>
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <input matInput placeholder=" Product Name" maxlength="255" class="font_regular" [formControl]="productNameCtrl" />
          <mat-error *ngIf="productNameCtrl.invalid && productNameCtrl.touched">Product Name is required</mat-error>
        </mat-form-field>
      </ion-col>

      <ion-col size="12" size-lg="3" size-md="6" >
        <label class="formLabelRegularfs16 mb-5">Plant Location <span class="red-cl">*</span></label>
         <ng-select class="w-100 mw-sm-250"
                    [clearable]="false"
                    placeholder="Select Plant"
                     [formControl]="plantCtrl"
                    appendTo="body"
                    dropdownPosition="top"
                  >
                    <ng-option *ngFor="let plant of plantList" [value]="plant.plantLocation">
                      {{ plant.plantLocation }}
                    </ng-option>
                  </ng-select>
            <div class="error-text" *ngIf="plantCtrl.invalid && plantCtrl.touched">
              Plant Location is required
            </div>
      </ion-col>

      <ion-col size="12" size-lg="3" size-md="6" >
        <label class="formLabelRegularfs16 mb-5">Business Unit <span class="red-cl">*</span></label>
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <input matInput placeholder=" Business Unit" maxlength="255" class="font_regular" [formControl]="businessUnitCtrl" />
          <mat-error *ngIf="businessUnitCtrl.invalid && businessUnitCtrl.touched">Business Unit is required</mat-error>
        </mat-form-field>
      </ion-col>

      <ion-col size="12" size-lg="3" size-md="6" >
        <label class="formLabelRegularfs16 mb-5">Customer Name <span class="red-cl">*</span></label>
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <input matInput placeholder=" Customer Name" maxlength="255" class="font_regular" [formControl]="customerCtrl" />
          <mat-error *ngIf="customerCtrl.invalid && customerCtrl.touched">Customer is required</mat-error>
        </mat-form-field>
      </ion-col>

        <ion-col size="12" size-lg="3" size-md="6" >
             <button   class="ml-10 mt-20 mb-10 add_btn" (click)="addProductData()">
      {{ isEdit ? 'Update Product' : 'Add Product' }}
      </button>
        </ion-col>
    </ion-row>

 
  </div>
</section>
